"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

require("./index.css");

var Tab = function (_a) {
  var activeTab = _a.activeTab,
      label = _a.label,
      onClick = _a.onClick,
      disabled = _a.disabled;
  var className = 'ui-tab-list-item';
  if (activeTab === label) className += ' ui-tab-list-active';
  if (disabled) className += ' ui-tab-list-inactive';
  return (0, jsx_runtime_1.jsx)("li", __assign({
    className: className,
    onClick: disabled ? function () {} : function () {
      return onClick(label);
    },
    "data-testid": label ? label.replace(' ', '') + "Tab" : '',
    role: "presentation",
    onKeyPress: function () {
      return onClick(label);
    },
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex: 0
  }, {
    children: label
  }), void 0);
};

var Tabs = function (_a) {
  var children = _a.children;

  var _b = (0, react_1.useState)(),
      activeTab = _b[0],
      setActiveTab = _b[1];

  var validChildren = children.filter(function (c) {
    return c;
  });
  (0, react_1.useEffect)(function () {
    if (!activeTab && validChildren.length > 0) {
      setActiveTab(validChildren[0].props.label);
    }
  }, [validChildren, activeTab]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "ui-tabs",
    "data-testid": "tabs-container"
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "ui-tabs-background"
    }, {
      children: (0, jsx_runtime_1.jsx)("ul", __assign({
        className: "ui-tab-list"
      }, {
        children: validChildren.map(function (child) {
          var _a = child.props,
              label = _a.label,
              disabled = _a.disabled;
          return (0, jsx_runtime_1.jsx)(Tab, {
            activeTab: activeTab,
            label: label,
            onClick: setActiveTab,
            disabled: disabled
          }, label);
        })
      }), void 0)
    }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "ui-tab-content"
    }, {
      children: validChildren.map(function (child) {
        if (child.props.label !== activeTab) return undefined;
        return child.props.children;
      })
    }), void 0)]
  }), void 0);
};

Tabs.propTypes = {
  children: (0, prop_types_1.instanceOf)(Array).isRequired
};
Tab.propTypes = {
  activeTab: prop_types_1.string,
  label: prop_types_1.string.isRequired,
  onClick: prop_types_1.func.isRequired
};
Tab.defaultProps = {
  activeTab: ''
};
exports.default = Tabs;